import DataReducer from "./DataReducer";

import { combineReducers } from "redux";

const rootReducer = combineReducers({
  DataReducer,
});

export default rootReducer;
